var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCafe(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 74,
    height: 72,
    viewBox: "0 0 74 72",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.1675 39.343C18.1675 39.343 17.4573 38.3541 14.3017 38.4212C13.8746 38.4212 13.4026 38.4526 12.8767 38.5063C7.83302 39.0119 3.95364 43.7191 4.42564 47.9431C4.73132 50.6637 6.63729 53.6079 9.81991 55.2948C11.6571 56.272 13.716 56.762 15.7986 56.7178C17.8765 56.7337 19.8894 55.9974 21.4625 54.646V54.646C21.9552 54.2083 22.3741 53.6946 22.7032 53.1247C23.3415 51.9658 23.3326 50.8874 22.6718 50.4802C21.6064 49.8314 19.5745 49.7867 17.6911 50.5518C15.8076 51.317 12.7103 51.4736 11.2943 48.6412C9.87835 45.8088 11.4337 43.4372 16.2706 44.001C20.55 44.5022 19.7319 42.2962 19.7319 42.2962",
    stroke: "#B250FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.1185 33.7135C33.1185 33.7135 40.0906 32.3711 41.2594 26.402C42.4281 20.4329 34.1659 14.5265 32.7634 10.8394C31.3609 7.1524 35.3796 3 35.3796 3",
    stroke: "#B250FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36.1707 9.39844C35.2717 13.4971 45.4893 16.7009 46.1142 23.0862C46.8154 30.2947 42.3562 33.0555 42.3562 33.0555",
    stroke: "#B250FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.82862 55.2944C4.32647 56.7487 1 58.6504 1 60.7221C1 65.2951 17.1154 69.0001 36.9978 69.0001C56.8801 69.0001 73 65.2951 73 60.7221C73 57.7465 66.1852 55.1468 55.9496 53.6836",
    stroke: "#B250FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M52.5961 29.7899C55.2438 30.7654 56.8486 31.9959 56.907 33.3383V33.4278C56.907 36.6226 48.1638 39.2179 37.3753 39.2179C27.7151 39.2179 19.6956 37.1372 18.1223 34.4077C17.9464 34.1108 17.8533 33.7725 17.8525 33.4278C17.8525 31.8975 19.8529 30.5059 23.1164 29.4678",
    stroke: "#B250FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2971 37.7894V38.0891C14.2522 35.3194 14.4365 32.3751 14.4365 32.3751V32.3438C14.4365 29.574 18.7564 27.122 25.225 25.7528C29.2531 24.9377 33.355 24.5388 37.4655 24.5625C40.8864 24.5527 44.3024 24.8236 47.6786 25.3724H47.7326C55.1902 26.6298 60.3462 29.2161 60.4631 32.2096V32.2364L60.4001 42.0805C60.3547 46.3572 58.7874 50.4793 55.9768 53.7143C51.7603 58.7303 44.9186 62.0639 37.4115 62.0639C30.6687 62.0639 24.8249 59.6432 20.6848 55.54",
    stroke: "#B250FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0298 44.1309C15.194 46.3956 15.8521 48.5974 16.9582 50.5832",
    stroke: "#B250FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCafe);
export default __webpack_public_path__ + "static/media/cafe.fab72d119fa0ca9cb3a0f30ed9cf60ed.svg";
export { ForwardRef as ReactComponent };